import {useGTMDispatch} from './react-gtm-hook/index'
import { transformAlgoliaItemsForGA4 } from './utils';

export const useSelectItemTracking = () => {
  const sendDataToGTM = useGTMDispatch();

  const sendSelectItemData = (hit, hitItemIndex, { viewingCategoryId, itemListId, itemListName }) => {
    let categoryName = [];

    for (const categoryArray of hit.categories) {
      for (const category of categoryArray) {
        if (category.id === viewingCategoryId) {
          let cleanedName = category.name.replace(/&#038;/g, '&');
          categoryName.push(cleanedName);
        }
      }
    }

    setTimeout(() => {
      try {
        const _items = transformAlgoliaItemsForGA4([hit], hitItemIndex, itemListName);
        _items[0].item_list_name = itemListName || '';

        sendDataToGTM({
          event: 'select_item',
          ecommerce: {
            item_list_id : itemListId ? itemListId : viewingCategoryId,
            item_list_name : itemListName ? itemListName : categoryName[0],
            currency : _items[0].currency,
            items : _items,
          }
        })
      } catch (error) {
        console.error('useSelectItemTracking error within setTimeout: ' + error.message);
      }
    }, 0);
  };
  return sendSelectItemData;
};